__turbopack_context__.v({
  "calloutSection": "PlasmicSecurityPractices-module__CDuwya__calloutSection",
  "contactModal": "PlasmicSecurityPractices-module__CDuwya__contactModal",
  "footer": "PlasmicSecurityPractices-module__CDuwya__footer",
  "header": "PlasmicSecurityPractices-module__CDuwya__header",
  "root": "PlasmicSecurityPractices-module__CDuwya__root",
  "securityPracticesBanner": "PlasmicSecurityPractices-module__CDuwya__securityPracticesBanner",
});
